import { render, staticRenderFns } from "./contentMapNum.vue?vue&type=template&id=27db73fa&scoped=true"
import script from "./contentMapNum.vue?vue&type=script&lang=js"
export * from "./contentMapNum.vue?vue&type=script&lang=js"
import style0 from "./contentMapNum.vue?vue&type=style&index=0&id=27db73fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27db73fa",
  null
  
)

export default component.exports